import { reactive } from 'vue'
import { defineStore } from 'vue_features/shared/composables/store_helpers'

export const useGatesMepStore = defineStore('gatesMep', () => {
  const state = reactive({
    enabled: false,
    thinkTilesEnabled: false,
    peerToPeerEnabled: false,
    gatesCooldownGuidanceEnabled: false,
    canViewFeedback: false,
    feedbackV2Enabled: false,
    feedbackV3Enabled: false,
    rewardsV3Enabled: false,
    gatesMisconceptionsGuidanceV3Enabled: false,
  })

  return {
    state,
  }
})
